/*
 * File: c:\Users\j.mazat\Desktop\Autobuy\AutobuyFrontOffice\AutobuyClient\src\Content\Password\PasswordRulesCheck\PasswordRulesCheck.tsx
 * Project: c:\Users\j.mazat\Desktop\Autobuy\AutobuyFrontOffice\AutobuyClient
 * Created Date: Tuesday September 19th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Tuesday September 19th 2023 2:41:03 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

import { useLang } from "Router/LangueProvider";
import Styles from "Content/Password/PasswordConfirm/PasswordConfirm.module.css";
import { useState } from "react";

type PasswordRulesCheckProps = {
    regexChecked: {
        length: boolean | null;
        min: boolean | null;
        maj: boolean | null;
        nb: boolean | null;
        spec: boolean | null;
    }
}

function PasswordRulesCheck(props: PasswordRulesCheckProps) {
    const {translator} = useLang();
    const [check, setCheck] = useState(props.regexChecked);
    return (
        <div className={`${Styles.flex}`}>
            <p className="mb-1">{translator.decode("users.rulesPassword.rules")}</p>
            <ul>
                <li className={check.length != null ? (check.length ? Styles.regexOk : Styles.regexWrong) : "" } >{translator.decode("users.rulesPassword.regexLength")}</li>
                <li className={check.min != null ? (check.min ? Styles.regexOk : Styles.regexWrong) : "" } >{translator.decode("users.rulesPassword.regexMin")}</li>
                <li className={check.maj != null ? (check.maj ? Styles.regexOk : Styles.regexWrong) : "" } >{translator.decode("users.rulesPassword.regexMaj")}</li>
                <li className={check.nb != null ? (check.nb ? Styles.regexOk : Styles.regexWrong) : "" } >{translator.decode("users.rulesPassword.regexNb")}</li>
                <li className={check.spec != null ? (check.spec ? Styles.regexOk : Styles.regexWrong) : "" } >{translator.decode("users.rulesPassword.regexSpec")}</li>
            </ul>
        </div>
    )
}

export default PasswordRulesCheck;
